import "core-js/modules/es.object.keys.js";
import { renderMarkdown } from '~/functions/markdown';
import { PromptEnum } from '~/types/types';
export default defineComponent({
  inheritAttrs: false,
  props: {
    text: {
      type: String,
      default: ''
    },
    options: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    secondText: {
      type: String,
      default: ''
    },
    showTranslateButton: {
      type: Boolean,
      default: false
    }
  },
  setup: function setup(_, context) {
    var _useNuxtApp = useNuxtApp(),
      $i18n = _useNuxtApp.$i18n;
    var locale = computed(function () {
      return $i18n.locale;
    });
    var showTranslationPreview = ref(false);
    var translatedPreviewText = ref('');
    var doNotShowAgain = ref(JSON.parse(localStorage.getItem('doNotShow.copyText') || 'false'));
    var doNotShowTranslationAgain = ref(JSON.parse(localStorage.getItem('doNotShow.translateText') || 'false'));
    watch(doNotShowAgain, function (val) {
      localStorage.setItem('doNotShow.copyText', JSON.stringify(val));
    });
    watch(doNotShowTranslationAgain, function (val) {
      localStorage.setItem('doNotShow.translateText', JSON.stringify(val));
    });
    var handleTranslation = function handleTranslation(translatedText) {
      if (doNotShowTranslationAgain.value) {
        emitTranslation(translatedText);
      } else {
        showPreview(translatedText);
      }
    };
    var showPreview = function showPreview(text) {
      translatedPreviewText.value = text;
      showTranslationPreview.value = true;
    };
    var emitTranslation = function emitTranslation(text) {
      context.emit('copy', text);
    };
    var acceptTranslation = function acceptTranslation() {
      emitTranslation(translatedPreviewText.value);
      closeTranslationPreview();
    };
    var closeTranslationPreview = function closeTranslationPreview() {
      showTranslationPreview.value = false;
      translatedPreviewText.value = '';
    };
    var replaceText = ref('');
    var overlay = ref(false);
    var useThisText = function useThisText(val) {
      if (doNotShowAgain.value) {
        emitTranslation(val);
      } else {
        overlay.value = true;
        replaceText.value = val;
      }
    };
    var onNo = function onNo() {
      overlay.value = false;
    };
    var onYes = function onYes() {
      overlay.value = false;
      emitTranslation(replaceText.value);
    };
    return {
      overlay: overlay,
      tab: ref(null),
      renderMarkdown: renderMarkdown,
      onNo: onNo,
      onYes: onYes,
      useThisText: useThisText,
      doNotShowAgain: doNotShowAgain,
      doNotShowTranslationAgain: doNotShowTranslationAgain,
      PromptEnum: PromptEnum,
      locale: locale,
      showTranslationPreview: showTranslationPreview,
      translatedPreviewText: translatedPreviewText,
      handleTranslation: handleTranslation,
      closeTranslationPreview: closeTranslationPreview,
      acceptTranslation: acceptTranslation
    };
  }
});